import { render, staticRenderFns } from "./ShunyiPatientInfoTable.vue?vue&type=template&id=8bdda23a&scoped=true"
import script from "./ShunyiPatientInfoTable.vue?vue&type=script&lang=js"
export * from "./ShunyiPatientInfoTable.vue?vue&type=script&lang=js"
import style0 from "./ShunyiPatientInfoTable.vue?vue&type=style&index=0&id=8bdda23a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdda23a",
  null
  
)

export default component.exports